// Dependecies
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Menu from './Menu';
import InternalMenu from './InternalMenu';
import InternalMenuCompany from './InternalMenuCompany';

function Header({ children, type, newMaintenances }) {
  if (typeof children !== 'undefined') {
    if (type === 0) {
      return (
        <header>
          <Menu />
        </header>
      );
    }
    if (type === 2) {
      return (
        <header>
          <InternalMenuCompany newMaintenances={newMaintenances} />
        </header>
      );
    }
    return (
      <header>
        <InternalMenu newMaintenances={newMaintenances} />
      </header>
    );
  }
  return (
    <header>
      <Menu />
    </header>
  );
}

Header.propTypes = {
  children: PropTypes.node,
  type: PropTypes.number,
  newMaintenances: PropTypes.number,
};

Header.defaultProps = {
  children: undefined,
  type: 0,
  newMaintenances: 0,
};

export default Header;
